import { Component, OnInit } from '@angular/core';
import { format } from 'date-fns';
import {  tap } from 'rxjs/operators';
import { CategoriesApiService, categoryRaw } from 'src/app/api/categories-api.service';
import { JarvisApiService, personData } from 'src/app/api/jarvis-api.service';
import { cliente, PcrcApiService } from 'src/app/api/pcrc-api.service';
import { posibleFilterFields, ReportsApiService } from 'src/app/api/reports-api.service';
import { Article } from 'src/app/article';
import { StateService } from 'src/app/services/state.service';
import {ExportExcelService} from 'src/app/api/export-excel.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import XLSX from 'xlsx'
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-base-datos',
  templateUrl: './base-datos.component.html',
  styleUrls: ['./base-datos.component.css']
})
export class BaseDatosComponent implements OnInit {
  

  public initialDateDrop = false
  public finalDateDrop = false
  
  public categoryDrop = false
  public articlesDrop = false

  public isDirectorActive = false
  public isGerenteActive = false
  public isCoordinadorActive = false
  public isLiderActive = false
  public isPcrcActive = false
  public isCategoriaActive = false
  public isArticleActive = false  
  cargando = false
  clientesList: cliente[]
  pcrcList: cliente['pcrcs'][0][]
  categoriesList: {
    state: "finish" | "loading";
    value?: categoryRaw[];
  }

  directores: personData[]
  gerentesList: personData[]
  coordisList: personData[]
  lideresList: personData[]

  selectedCliente: cliente
  selectedPcrc: cliente['pcrcs'][0]
  selectedCategory: categoryRaw
  selectedArticle: Article

  selectedDirector: personData
  selectedGerente: personData
  selectedCoordi: personData
  selectedLider: personData

  initialDate:Date
  finalDate:Date
  initialDateHumanRead = ''
  finalDateHumanRead = ''
  initialDateParam=''
  finalDateParam=''

  data:any;
  verificar:boolean;
  currentPage = 1;
  pageSize = 12;
  totalItems:number = 0;
   p=1
  tableIsLoading = false;
   textClient=""
   textPcrc=""
  constructor(
    public state: StateService,
    public pcrcApi: PcrcApiService,
    public jarvisApi: JarvisApiService,
    public categoriesApi: CategoriesApiService,
    public reportsApi: ReportsApiService,
    public excelservice:ExportExcelService,
    public router :Router, 
    private translate: TranslateService
  ) { }
 
  ngOnInit() {
    this.cargando = true

    this.pcrcApi.getUserPcrc(this.state.getValueOf('user').sub, 0, 1000).pipe(
      tap(pcrcs => {
        this.clientesList = [ { cliente:'Cualquiera', id_dp_clientes:0, pcrcs:[] }, ...pcrcs]
        this.cargando = false

      })
    ).subscribe()

    this.verificar=false;

  }

  getClient(event){
      this.textClient = event
  }

  getPcrc(event){
      this.textPcrc = event
  }

  clienteSelected(selectedClient: cliente) {

    this.selectedCliente = selectedClient

    this.isPcrcActive = true

    this.pcrcList = [ { cod_pcrc:'0', id_dp_pcrc:0, pcrc:'Cualquiera' } , ...selectedClient.pcrcs ]

    this.categoriesList = null

    this.selectedCategory = null

    this.selectedPcrc = null

  }

  pcrcSelected(event: cliente['pcrcs'][0]) {

    this.selectedPcrc = event

    this.selectedCategory = null

    this.categoriesApi.getCategories(this.selectedPcrc.id_dp_pcrc.toString()).pipe(
      tap(categories => {
        if(categories.state == 'finish'){
          this.categoriesList = { state:'finish', value:[ {
            icon:'',
            id:'',
            name:'Cualquiera',
            base_id:'',
            position:0
          }, ...categories.value] }

        } else {
          this.categoriesList = categories

        }

        this.isCategoriaActive = true;
      })
    ).subscribe()

  }

  categorySelected(event: categoryRaw) {

    this.selectedCategory = event

    this.isArticleActive = true

  }

  articleSelected(event: Article) {
    this.articlesDrop = false
    this.selectedArticle = event
  }

  onInitialDateChange(event: { value: Date }) {
    this.initialDate = event.value
    this.initialDate.setHours(0)
    this.initialDate.setMinutes(0)
    this.initialDateHumanRead = format(this.initialDate, "dd/MM/y")
    this.initialDateParam = format(this.initialDate, "y/MM/dd")
  }

  onFinalDateChange(event: { value: Date }) {
    this.finalDate = event.value
    this.finalDate.setHours(23)
    this.finalDate.setMinutes(59)
    this.finalDateHumanRead = format(this.finalDate, "dd/MM/y")
    this.finalDateParam = format(this.finalDate, "y/MM/dd")
  } 

  search() {
    this.getFilters();
  }

  getverify(data){

    if((([].concat.apply({}, data).length)-1)===0){
      this.verificar=false;
   }else{
     this.verificar=true;
   }
  }

  getFilters() {


   if(!this.textClient){
     return Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: this.translate.instant('Selecciona el cliente')
    })
   }

   if(!this.textPcrc){
    return Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: this.translate.instant('Selecciona el pcrc')
    })
  }

   document.getElementById('table').classList.remove('hide')
   document.getElementById('table').classList.add('show')

    this.tableIsLoading=true

    let filter1: { filter: posibleFilterFields, value: string }


    if (!!this.selectedCliente && this.selectedCliente.cliente != 'Cualquiera') {
      filter1 = { value: this.selectedCliente.id_dp_clientes.toString(), filter: 'cliente' }

      if (!!this.selectedPcrc && this.selectedPcrc.pcrc != 'Cualquiera') {
        filter1 = { value: this.selectedPcrc.id_dp_pcrc.toString(), filter: 'pcrc' }

        if(this.selectedCategory==null){
          let data=this.reportsApi.getBasesPcrc(this.selectedPcrc.id_dp_pcrc);
          data.subscribe(
              (data:any)=>{
                this.data = data
              
                this.getverify(data)
                this.tableIsLoading=false
              }
            ) 
        }

        if (!!this.selectedCategory && this.selectedCategory.name != 'Cualquiera') {
          filter1 = { value: this.selectedCategory.id, filter: 'categoria' }
          
          if(this.selectedArticle==null){
            let data=this.reportsApi.getBasesCategory(this.selectedCategory.id);
            data.subscribe(
              (data:any)=> {
                 
                 this.data= data
            
                 this.getverify(data)
                 this.tableIsLoading=false
               }
              ) 
          }

          if (!!this.selectedArticle && this.selectedArticle.title != 'Cualquiera') {
            filter1 = { value: this.selectedArticle.id, filter: 'articulo' }

             let data=this.reportsApi.getBases(this.selectedArticle.id);
            data.subscribe(
               (data:any)=> {
                 this.data= data
                
                 this.getverify(data)
                 this.tableIsLoading=false
               }
              )  

          }
        }
      }
    }

  }

 limpiar(){
   this.router.navigate(['/app/redirect/base'])
 }

 exportExcel(){
  
      let result =  this.data.map((item:any) => {
        if(item.indiceUtilidad==null || item.indiceNoUtilidad==null ){ 
          item.indiceUtilidad = 0
          item.indiceNoUtilidad = 0
          item.tasarebote = item.tasarebote == null ? "0" : parseInt(item.tasarebote).toFixed()
          return item
        }else{
          item.indiceUtilidad = item.indiceUtilidad          
          item.indiceNoUtilidad = item.indiceNoUtilidad
          item.tasarebote = item.tasarebote == null ? "0" : parseInt(item.tasarebote).toFixed()
          return item
        }
      });

    const ws:XLSX.WorkSheet = XLSX.utils.json_to_sheet(result)
    const wb:XLSX.WorkBook  = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb,ws,'sheet1')
     XLSX.writeFile(wb, 'baseDatos.xlsx')
    
  }

  formatearValor(valor:any){
    return isNaN(valor) ? valor : parseFloat(valor).toFixed();
  }

}